// DMS API inventory - generated from the backend route file and controllers.
// Source: nbl-dms-dev-backend/routes/api.php (active routes only). Descriptions come from each
// handler's docblock/comment (or its method name when it has none); auth comes
// from the handler's Auth::guard('api')->check() gate; usedBy lists the DMS UI
// files that call the endpoint. Only DMS routes are included: SugarCRM
// integration routes (commented out in api.php) are not part of the DMS API.
// Regenerate this file when routes change; do not edit entries by hand.

const dmsApiInventory = {
  "source": "nbl-dms-dev-backend/routes/api.php",
  "generatedOn": "2026-09-23",
  "modules": [
    {
      "name": "Authentication",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/user",
          "description": "Return the authenticated user",
          "handler": "(closure)@returns $request->user()",
          "auth": "Middleware auth:sanctum",
          "usedBy": [],
          "shadowed": true
        },
        {
          "method": "POST",
          "endpoint": "/api/login",
          "description": "Login User",
          "handler": "UserController@loginUser",
          "auth": "Public (issues access token)",
          "usedBy": []
        },
        {
          "method": "GET",
          "endpoint": "/api/user",
          "description": "Get User Detail",
          "handler": "UserController@getUserDetail",
          "auth": "Bearer token (api guard)",
          "usedBy": []
        },
        {
          "method": "GET",
          "endpoint": "/api/logout",
          "description": "User Logout",
          "handler": "UserController@userLogout",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "email",
              "rules": "required|email",
              "from": "validation"
            },
            {
              "name": "password",
              "rules": "required",
              "from": "validation"
            }
          ]
        }
      ]
    },
    {
      "name": "Webhook Posts",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/posts",
          "description": "Display a listing of the resource",
          "descriptionFull": "Display a listing of the resource.",
          "handler": "PostController@index",
          "auth": "Bearer token (api guard)",
          "usedBy": []
        },
        {
          "method": "GET",
          "endpoint": "/api/testing",
          "description": "",
          "handler": "PostController@testing",
          "auth": "",
          "usedBy": [],
          "handlerMissing": true
        },
        {
          "method": "POST",
          "endpoint": "/api/posts",
          "description": "Store a newly created resource in storage",
          "descriptionFull": "Store a newly created resource in storage.",
          "handler": "PostController@store",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "title",
              "rules": "",
              "from": "code"
            },
            {
              "name": "hooktype",
              "rules": "",
              "from": "code"
            },
            {
              "name": "postdata",
              "rules": "",
              "from": "code"
            },
            {
              "name": "description",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/posts/{post}",
          "description": "Display the specified resource",
          "descriptionFull": "Display the specified resource.",
          "handler": "PostController@show",
          "auth": "Bearer token (api guard)",
          "usedBy": []
        }
      ]
    },
    {
      "name": "Users & Roles",
      "apis": [
        {
          "method": "POST",
          "endpoint": "/api/login_users",
          "description": "Function for logging in the user",
          "handler": "UserController@login_user",
          "auth": "Public (issues access token)",
          "usedBy": [
            "api/login.js",
            "api/loginDev.js"
          ],
          "params": [
            {
              "name": "email",
              "rules": "required|email",
              "from": "validation"
            },
            {
              "name": "password",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/logout_users",
          "description": "Function for logging out the user",
          "handler": "UserController@logout_user",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/logout.js"
          ],
          "params": [
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "user_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "first_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "last_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "is_admin",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get_user_data",
          "description": "Fetch all data from User table with / without filtering",
          "handler": "UserController@getUserData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/role-table/DataToolbar.jsx",
            "components/user-table/DataToolbar.jsx",
            "pages/Users.jsx"
          ],
          "params": [
            {
              "name": "first_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "last_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "status",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "permissions",
              "rules": "array|required",
              "from": "validation"
            },
            {
              "name": "role_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "user_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "is_admin",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            },
            {
              "name": "roleId",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-user",
          "description": "Add records in User table",
          "handler": "UserController@addUser",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addUser.js"
          ],
          "params": [
            {
              "name": "first_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "last_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "email",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "is_admin",
              "rules": "",
              "from": "code"
            },
            {
              "name": "role_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-user-data",
          "description": "update user's details",
          "handler": "UserController@updateUserData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/changeUserStatus.js",
            "api/editUser.js"
          ],
          "params": [
            {
              "name": "id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "first_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "last_name",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-user-record",
          "description": "Soft Delete the record/s from user table",
          "handler": "UserController@deleteUserRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteUser.js"
          ],
          "params": [
            {
              "name": "id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get_deleted_user_data",
          "description": "Fetch Deleted Records from User with / without filtering",
          "handler": "UserController@getDeletedUsers",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/trashed-user/DataToolbar.jsx",
            "pages/TrashUsers.jsx"
          ],
          "params": [
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "user_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "first_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "last_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "is_admin",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/restore-deleted-record",
          "description": "Restore Deleted Records from Users table",
          "handler": "UserController@restoreDeleteRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/restoreUser.js"
          ],
          "params": [
            {
              "name": "id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-permanant-user-record",
          "description": "Delete Records Permanantly from User table",
          "handler": "UserController@deletePermanentUserRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/permanentlyDeleteUser.js"
          ],
          "params": [
            {
              "name": "id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-roles",
          "description": "For Adding the Role and its permissions",
          "handler": "UserController@addRoles",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addRole.js"
          ],
          "params": [
            {
              "name": "name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "status",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "permissions",
              "rules": "array|required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-roles",
          "description": "For Updating Roles' details and its permissions",
          "handler": "UserController@updateRoles",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/editRole.js"
          ],
          "params": [
            {
              "name": "role_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "status",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "permissions",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-roles",
          "description": "Get Roles List with / without filtering",
          "handler": "UserController@getRoles",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "pages/Roles.jsx"
          ],
          "params": [
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-permissions",
          "description": "Get Permissions of Users, based on the roles",
          "handler": "UserController@getPermissions",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "role_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-role",
          "description": "Soft Delete the record from roles table",
          "handler": "UserController@deleteRole",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteRole.js"
          ],
          "params": [
            {
              "name": "role_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-role-details",
          "description": "Get Roles details including permissions",
          "handler": "UserController@getRoleDetails",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "context/RolesContext.jsx"
          ],
          "params": [
            {
              "name": "roleId",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-user-roles",
          "description": "Get all active user roles",
          "handler": "UserController@getUserRoles",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/user-table/AddUser.jsx",
            "components/user-table/EditUserPopup.jsx"
          ]
        }
      ]
    },
    {
      "name": "Client Document Access (OTP)",
      "apis": [
        {
          "method": "POST",
          "endpoint": "/api/send-otp-to-client",
          "description": "For sending the Verification Code to view the document to Client's phone number",
          "handler": "ClientController@sendViewDocOTP",
          "auth": "None (public)",
          "usedBy": [],
          "params": [
            {
              "name": "client_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "filename",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/verify-view-document-otp",
          "description": "For verification of Phone Number for viewing the document",
          "handler": "ClientController@verifyViewDocumentOTP",
          "auth": "None (public)",
          "usedBy": [],
          "params": [
            {
              "name": "verification_code",
              "rules": "required|string",
              "from": "validation"
            },
            {
              "name": "client_id",
              "rules": "required|string",
              "from": "validation"
            },
            {
              "name": "filename",
              "rules": "required|string",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/send_doc_link_sms",
          "description": "For sending the Link for viewing the document to Client's phone number",
          "handler": "ClientController@sendDocLinkSMS",
          "auth": "None (public)",
          "usedBy": [
            "api/sendDocLinkSMS.js"
          ],
          "params": [
            {
              "name": "phone",
              "rules": "",
              "from": "code"
            },
            {
              "name": "doc_link",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "Clients",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-all-client-data",
          "description": "API for fetching the data of clientd with / without filtering",
          "handler": "ClientController@getAllClientData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/client-verification/client-verfication-queries.js",
            "components/client-table/DataToolbar.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "case_client_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "case_sub_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_reference_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-client-name",
          "description": "Get Client Name on the basis of Contact ID",
          "handler": "ClientController@getClientName",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getClientName.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-client-reference-number",
          "description": "Get Client Refernce Number based on Contact ID",
          "handler": "ClientController@getClientReferenceNumber",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getClientRefNo.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-client-phone-number",
          "description": "Get Client Phone Number based on Contact ID",
          "handler": "ClientController@getClientPhoneNumber",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getClientPhone.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-client-email",
          "description": "Get Client Email based on Contact ID",
          "handler": "ClientController@getClientEmail",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/contracts/AddContracts.jsx"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-client-data",
          "description": "This function is add new record of client into Client table",
          "handler": "ClientController@addClientData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addClient.js"
          ],
          "params": [
            {
              "name": "name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sub_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "country_code",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_reference_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "lead_attorney",
              "rules": "",
              "from": "code"
            },
            {
              "name": "legal_assistant",
              "rules": "",
              "from": "code"
            },
            {
              "name": "paralegal",
              "rules": "",
              "from": "code"
            },
            {
              "name": "case_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "im_case_type",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-client-table-data",
          "description": "This function is used to update the Client's details",
          "handler": "ClientController@updateClientTableData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/editClient.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sub_type",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-client-table-data",
          "description": "Soft delete the record/s from Client table & also doing the soft delete of Documents, Document Requests & Beneficiaries associated with…",
          "descriptionFull": "Soft delete the record/s from Client table & also doing the soft delete of Documents, Document Requests & Beneficiaries associated with the deleted client/s",
          "handler": "ClientController@deleteClientTableRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteClient.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/restore-deleted-client",
          "description": "For Restoring Client and Associated Documents & DoumentRequests Records",
          "handler": "ClientController@restoreDeletedClient",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/reset-client-callback-created",
          "description": "To Reset Callback Created field to default value - False",
          "handler": "ClientController@resetClientCallbackCreated",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "required|exists:",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-case-details",
          "description": "Get Client Details on the basis of Contact ID",
          "handler": "ClientController@getClientDetails",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getAllCaseDetails.js"
          ],
          "params": [
            {
              "name": "caseId",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/getCaseStatus",
          "description": "Get Client Status Details on the basis of Contact ID",
          "handler": "ClientController@getClientStatus",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/all-case-list/case-list-table/CaseListTable.jsx",
            "components/all-case-list/case-table/AllDocumentsList.jsx",
            "components/client-table/client-documents/PDFViewer.jsx",
            "components/common/BusinessCardInfo.jsx",
            "components/common/ClientInfoPanel.jsx",
            "components/document-table/AddDocument.jsx",
            "components/email-case-list/case-list-table/CaseListTable.jsx",
            "components/pdf-viewer/PdfViewer.jsx"
          ],
          "params": [
            {
              "name": "caseId",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/customGlobalSearch",
          "description": "Searches the local clients + client_link_contacts tables by name, phone, email, client reference number, or contact id, and returns…",
          "descriptionFull": "Searches the local clients + client_link_contacts tables by name, phone, email, client reference number, or contact id, and returns results in the same {records, total} shape the frontend already expects",
          "handler": "ClientController@customGlobalSearch",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/all-case-list/case-list-table/CaseListTable.jsx",
            "components/all-case-list/case-table/AllDocumentsList.jsx",
            "components/document-table/AddDocument.jsx",
            "components/email-case-list/case-list-table/CaseListTable.jsx",
            "components/pdf-viewer/PdfViewer.jsx"
          ],
          "params": [
            {
              "name": "q",
              "rules": "",
              "from": "code"
            },
            {
              "name": "max_num",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "Linked Contacts",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-client-link-data",
          "description": "For getting all Beneficaries of contact_id with / without filtering",
          "handler": "ClientController@getClientLinkData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/client-table/client-documents/all-documents/beneficiary/BeneficiaryTabList.jsx",
            "components/client-table/client-documents/all-documents/BeneficiaryTable.jsx",
            "components/client-table/client-documents/RequestDocumentsPopup.jsx"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-beneficiary-data",
          "description": "",
          "handler": "ClientController@addBeneficiaryData",
          "auth": "",
          "usedBy": [],
          "handlerMissing": true
        },
        {
          "method": "POST",
          "endpoint": "/api/add-client-link-data",
          "description": "Have to discuss the",
          "handler": "ClientController@addclientlinkdata",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addAdditionalContacts.js"
          ],
          "params": [
            {
              "name": "contacts",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-client-link-table-data",
          "description": "Update Beneficiary Records",
          "handler": "ClientController@updateClientLinkContact",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/editBeneficiary.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-client-link-table-data",
          "description": "Soft delete record of Client Link Contact Table & also doing the soft delete of Documents & Document Requests associated with the…",
          "descriptionFull": "Soft delete record of Client Link Contact Table & also doing the soft delete of Documents & Document Requests associated with the deleted Beneficiaries",
          "handler": "ClientController@deleteClientLinkContact",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteBeneficiary.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        }
      ]
    },
    {
      "name": "Document Request Templates",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-document-req-settings-data",
          "description": "It is used to get data from Document Request Setting Table",
          "handler": "SettingsController@getDocumentReqSettingsData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/document-request-setting/DataToolbar.jsx",
            "components/document-request-setting/DocumentRequestSettingsTable.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_desc",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "request_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fields_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_subtype",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-document-request-setting-data",
          "description": "It is used to add data into Document Request Setting table",
          "handler": "SettingsController@addDocumentReqSettingsData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addDocumentRequestSettings.js"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_name_es",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_desc",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "client_type",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "request_type",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "sample_document_link",
              "rules": "",
              "from": "code"
            },
            {
              "name": "service_sub_type_c",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "ocr_status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-document-name-by-client-type",
          "description": "Fetch Document from Document Request Setting Table on the basis of client type and document stage",
          "handler": "SettingsController@getDocumentNameByClientType",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/requestDocumentPopup.js"
          ],
          "params": [
            {
              "name": "service_sub_type_c",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-document-request-setting-data",
          "description": "Update Document Request Setting Records",
          "handler": "SettingsController@updateDocumentRequestSettingData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/changeDocumentRequestSettingsStatus.js",
            "api/editDocumentRequestSettings.js"
          ],
          "params": [
            {
              "name": "document_request_setting_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-document-request-setting-data",
          "description": "Delete Document Request Setting Record",
          "handler": "SettingsController@deleteDocRequestSettingRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteDocumentRequestSettings.js"
          ],
          "params": [
            {
              "name": "document_request_setting_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        }
      ]
    },
    {
      "name": "Document Requests",
      "apis": [
        {
          "method": "POST",
          "endpoint": "/api/add-doc-request-data",
          "description": "Add data into Document request table",
          "handler": "DocumentController@addDocumentRequestdata",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_request_setting_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "reason_for_doc_rejection",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-doc-request-data",
          "description": "Fucntion is used to get all data from Document request table for a particular contact_id",
          "handler": "DocumentController@getDocumentRequestData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/client-table/client-documents/all-documents/DataToolbar.jsx",
            "components/client-table/client-documents/RequestedDocumentsList.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "linked_client_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_req_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_stage",
              "rules": "",
              "from": "code"
            },
            {
              "name": "unlinked",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-client-doc-request-data",
          "description": "Fucntion is used to get all data from Document request table for a particular contact_id from the upload document portal and client portal",
          "handler": "DocumentController@getClientDocumentRequestData",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "lang",
              "rules": "",
              "from": "code"
            },
            {
              "name": "linked_client_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-document-request-category",
          "description": "Function Sort Help",
          "handler": "DocumentController@updateDocumentRequestCategory",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/updateRequestedDocumentCategory.js"
          ],
          "params": [
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_category",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-document-request-all-data",
          "description": "Update all records of Document Request Table",
          "handler": "DocumentController@updateDocumentRequestData",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-document-request-data",
          "description": "Update Document Status Field of Document Request Table",
          "handler": "DocumentController@updateDocumentRequestStatus",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/approveRequestedCase.js"
          ],
          "params": [
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_status",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "user_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/reject-document",
          "description": "Update document_status field as Rejected and also update the reason document rejection",
          "handler": "DocumentController@rejectDocument",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/rejectRequestedCase.js"
          ],
          "params": [
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_status",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "reason_for_doc_rejection",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "user_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-document-request-table-data",
          "description": "Bulk Delete record from Document Request Table",
          "handler": "DocumentController@deleteDocumentRequestTableRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteRequestedClient.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_request_setting_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_request_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/link-dms-document",
          "description": "This Function is fetching the document_url field from documents table added into document_uploaded_url on the basis of cliend_id and…",
          "descriptionFull": "This Function is fetching the document_url field from documents table added into document_uploaded_url on the basis of cliend_id and document_name",
          "handler": "DocumentController@linkdmsdocument",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_name",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/link-document-url",
          "description": "Function is fetching the document_url from Documents table and uploading it in document_uploaded_url field in Document Request table",
          "handler": "DocumentController@linkDocumentUrl",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/linkDocument.js"
          ],
          "params": [
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/view-document-by-document-request-id",
          "description": "View Document Uploaded Url on the basis of document_request_id",
          "handler": "DocumentController@viewDocumentByDocumentRequestId",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/downloadLink.js"
          ],
          "params": [
            {
              "name": "document_request_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-multiple-doc-request-data",
          "description": "Adding multiple document requests",
          "handler": "DocumentController@addMultipleDocumentRequests",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/saveRequestedDocument.js"
          ],
          "params": [
            {
              "name": "reason_for_doc_rejection",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-doc-requested-data-of-client",
          "description": "Get Document Requested Data of Clients",
          "handler": "DocumentController@getDocumentRequestedOfClient",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/requests/DataToolbar.jsx",
            "pages/DocumentsReports.jsx",
            "pages/Requests.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contact_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "requested_by",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-pending-request",
          "description": "Retrive the Client Name who is not requested any document",
          "handler": "DocumentController@getPendingRequest",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/dashboardPendingRequests.js"
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-recent-upload",
          "description": "Retrieve Client Name whose status is Uploaded",
          "handler": "DocumentController@getRecentUpload",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/dashboardRecentUploads.js"
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-deleted-requests",
          "description": "For getting Deleted Document Request",
          "handler": "DocumentController@getDeletedDocumentRequest",
          "auth": "Bearer token (api guard)",
          "usedBy": []
        },
        {
          "method": "PUT",
          "endpoint": "/api/restore-deleted-requests",
          "description": "Restore Deleted Document Records",
          "handler": "DocumentController@restoreDeletedDocumentRequest",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/view-fav-document",
          "description": "View Favourite Document",
          "handler": "DocumentController@viewFavDocument",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/viewFavDoc.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required|uuid",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/send_mail_database_entry",
          "description": "This function is sending email and document_link in the basis of contact_id from Documents table(For Share button)",
          "handler": "DocumentController@sendMaildatabaseEntry",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/sendEmail.js"
          ],
          "params": [
            {
              "name": "recipient_email_id",
              "rules": "required|email",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "recipient_name",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-document-status",
          "description": "Get Document Status based on document_request_id",
          "handler": "DocumentController@getDocumentStatus",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getDocumentRequestStatus.js"
          ],
          "params": [
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-all-otps",
          "description": "Delete All OTPs from 2fa Verification table",
          "handler": "DocumentController@deleteAllOtps",
          "auth": "Bearer token (api guard)",
          "usedBy": []
        },
        {
          "method": "GET",
          "endpoint": "/api/get-document-request-for-linking",
          "description": "Document Request List for Linking with Documents",
          "handler": "DocumentController@getDocumentRequestForLinking",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-client-document-requests-for-linking",
          "description": "All Document Request List including pending ones for Linking with Documents",
          "handler": "DocumentController@getClientDocumentRequestForLinking",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/all-case-list/case-list-table/CaseListTable.jsx",
            "components/all-case-list/case-table/AllDocumentsList.jsx",
            "components/client-table/client-documents/all-documents/UploadDocumentsPopup.jsx",
            "components/client-table/client-documents/PDFViewer.jsx",
            "components/document-table/AddDocument.jsx",
            "components/email-case-list/case-list-table/CaseListTable.jsx",
            "components/pdf-viewer/PdfViewer.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-request-name",
          "description": "For getting the request name",
          "handler": "DocumentController@getRequestName",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/all-case-list/case-list-table/CaseListTable.jsx",
            "components/all-case-list/case-table/AllDocumentsList.jsx",
            "components/client-table/client-documents/RequestedDocumentsList.jsx",
            "components/email-case-list/case-list-table/CaseListTable.jsx"
          ],
          "params": [
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-user-documents-summary",
          "description": "For Getting the Count of documents(Assigned, Processed & Pending) for each Users",
          "handler": "DocumentController@getUserDocumentSummaryForDashboard",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/documents-reports/UserCards.jsx"
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-user-documents-timebased-summary",
          "description": "For Getting the Count of documents(Assigned, Processed & Pending) for each Users based on date range",
          "handler": "DocumentController@getUserDocumentTimeBasedSummary",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getUserDocumentsTimeSummary.js"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "Documents",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-all-doc-data",
          "description": "This function is used get all data from Document table",
          "descriptionFull": "This function is used get all data from Document table.",
          "handler": "DocumentController@getAllDocumentData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/client-table/client-documents/all-documents/uploaded/DataToolbar.jsx",
            "components/client-table/client-documents/all-documents/uploaded/DocumentTable.jsx",
            "components/document-table/DataToolbar.jsx",
            "components/document-table/DocumentTable.jsx",
            "components/pdf-viewer/PdfViewer.jsx",
            "pages/Documents.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "roleId",
              "rules": "",
              "from": "code"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assignUserId",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "linked_client_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_request_setting_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "doc_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_subtype",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "category_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-document-count-dashboard",
          "description": "For Getting the Count of Mailroom section document for Dashboard UI",
          "handler": "DocumentController@getDocumentCountForDashboard",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/dashboardDocumentCount.js"
          ],
          "params": [
            {
              "name": "isAdmin",
              "rules": "",
              "from": "code"
            },
            {
              "name": "roleId",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-processed-user-count-dashboard",
          "description": "For Getting the Count of Users who approved documents for Dashboard UI",
          "handler": "DocumentController@getProcessedUserCountForDashboard",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getProcessedUserCount.js"
          ],
          "params": [
            {
              "name": "all",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-processed-today-user-count-dashboard",
          "description": "For Getting the Count of Users who processed documents Today",
          "handler": "DocumentController@getProcessedTodayUserCountForDashboard",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getProcessedTodayUserCount.js"
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-document-data",
          "description": "This function is add the data into Document table",
          "descriptionFull": "This function is add the data into Document table.",
          "handler": "DocumentController@addDocumentData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addDocument.js"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_url",
              "rules": "required|file",
              "from": "validation"
            },
            {
              "name": "favourite",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_request_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_reference_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_desc",
              "rules": "",
              "from": "code"
            },
            {
              "name": "user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_sub_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "category_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "content_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_version",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_from_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_hash",
              "rules": "",
              "from": "code"
            },
            {
              "name": "ocr_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "receiver_email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_unknown",
              "rules": "",
              "from": "code"
            },
            {
              "name": "forwarder_name",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-document-data-for-salesforce",
          "description": "This function is add Document from Salesforce through encoded or decoded fucntionality",
          "descriptionFull": "This function is add Document from Salesforce through encoded or decoded fucntionality.",
          "handler": "DocumentController@addDocumentDataForSalesForce",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_desc",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_url",
              "rules": "required|string",
              "from": "validation"
            },
            {
              "name": "document_status",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "category_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_sub_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "content_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_version",
              "rules": "",
              "from": "code"
            },
            {
              "name": "favourite",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_from_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_hash",
              "rules": "",
              "from": "code"
            },
            {
              "name": "ocr_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "receiver_email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_reference_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_unknown",
              "rules": "",
              "from": "code"
            },
            {
              "name": "forwarder_name",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-document-table-data",
          "description": "Update the Document Table fields",
          "descriptionFull": "Update the Document Table fields.",
          "handler": "DocumentController@updateDocumentData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/editDocument.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_request_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_desc",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-document-table-data",
          "description": "Delete record from Document table",
          "descriptionFull": "Delete record from Document table.",
          "handler": "DocumentController@deleteDocumentTableRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteDocument.js"
          ],
          "params": [
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_ids",
              "rules": "",
              "from": "code"
            },
            {
              "name": "section",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/permanant-delete-document-table-data",
          "description": "For Permanantly Deleting Record from Documents Table",
          "handler": "DocumentController@permanantdeleteDocumentRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/permanentlyDeleteDocument.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/view-document-req-url-link",
          "description": "View Document By Document Id and Document Table , If document_table will not be first it will search document_id in document_version…",
          "descriptionFull": "View Document By Document Id and Document Table , If document_table will not be first it will search document_id in document_version then documents table",
          "handler": "DocumentController@viewDocument",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/pdfDetails.js",
            "api/viewDocumentLink.js"
          ],
          "params": [
            {
              "name": "document_table",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_version_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/view-documents-bulk-link",
          "description": "View Document Links for Multiple Documents By an array/comma-separated list of document_id — resolves each document via…",
          "descriptionFull": "View Document Links for Multiple Documents By an array/comma-separated list of document_id — resolves each document via resolveDocumentLink(), skipping any id that can't be found or errors out, and returns links for whichever documents were resolved successfully.",
          "handler": "DocumentController@viewDocumentsBulk",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/viewDocumentsBulkLink.js"
          ],
          "params": [
            {
              "name": "document_table",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_ids",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/download-document-proxy",
          "description": "Streams a resolved document's bytes back through the API instead of the browser fetching the stored file URL directly",
          "descriptionFull": "Streams a resolved document's bytes back through the API instead of the browser fetching the stored file URL directly. The static file host serving uploaded documents doesn't send CORS headers, so a cross-origin client-side fetch() (used by the bulk-download flow) is blocked by the browser even though the file itself is reachable. Routing the download through Laravel picks up the app's own CORS config (config/cors.php + HandleCors middleware), which does allow the frontend origin.",
          "handler": "DocumentController@downloadDocumentProxy",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/all-case-list/case-list-table/CaseListTable.jsx",
            "components/all-case-list/case-table/AllDocumentsList.jsx",
            "components/client-table/client-documents/all-documents/uploaded/DocumentTable.jsx",
            "components/document-table/DocumentTable.jsx",
            "components/email-case-list/case-list-table/CaseListTable.jsx"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_table",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-fav-data",
          "description": "Function is used to get all fields data which have value 1 in favourite field",
          "handler": "DocumentController@getFavouriteColData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/starred-document-table/DataToolbar.jsx",
            "pages/Starred.jsx"
          ],
          "params": [
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_version",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_by_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/favourtite-bulk-all",
          "description": "This API is making multiple favourite records in Documents table",
          "handler": "DocumentController@favouriteBulkAll",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addBulkFavouriteDocument.js",
            "api/addFavouriteDocument.js"
          ],
          "params": [
            {
              "name": "ids",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/remove-bulk-all-favourite",
          "description": "This API is for making multiple records as Unfavourite",
          "handler": "DocumentController@removeFavouriteBulkAll",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/removeBulkFavouriteDocuments.js",
            "api/removeFavouriteDocument.js"
          ],
          "params": [
            {
              "name": "ids",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-document-name",
          "description": "Getting all the docuemnt names from Documents table on the basis of clinet_id",
          "handler": "DocumentController@getDocumentName",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getAllDocumentList.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/upload-multiple-document-data",
          "description": "For uploading multiple documents in Documents table",
          "handler": "DocumentController@uploadMultipleDocumentData",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "documents",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/sample_blob_data",
          "description": "Function Sort Help",
          "handler": "DocumentController@sampleBlobData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/pdfBase64Data.js"
          ],
          "params": [
            {
              "name": "document_table",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-additional-document",
          "description": "For uploading Additional Document",
          "handler": "DocumentController@addAdditionalDocument",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addAdditionalDocument.js"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_url",
              "rules": "required|file",
              "from": "validation"
            },
            {
              "name": "document_desc",
              "rules": "",
              "from": "code"
            },
            {
              "name": "category_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_sub_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "content_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_unknown_phone",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_unknown_email",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_version",
              "rules": "",
              "from": "code"
            },
            {
              "name": "favourite",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/additionalUrlLink",
          "description": "Additional Url Link",
          "handler": "DocumentController@additionalUrlLink",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_request_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-deleted-document",
          "description": "Get Deleted Document Records",
          "handler": "DocumentController@getDeletedDocuments",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/bin/document-bin/DataToolbar.jsx",
            "components/bin/document-bin/TrashDocumentsTable.jsx"
          ],
          "params": [
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "del_doc_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_subtype",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "category_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_request_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_reference_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/restore-deleted-document",
          "description": "Restore Deleted Document Records",
          "handler": "DocumentController@restoreDeletedDocument",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/restoreDocument.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-outlook-document",
          "description": "",
          "handler": "DocumentController@getOutlookDocument",
          "auth": "",
          "usedBy": [],
          "handlerMissing": true
        },
        {
          "method": "GET",
          "endpoint": "/api/get-docu-seal",
          "description": "",
          "handler": "DocumentController@getDocuSeal",
          "auth": "",
          "usedBy": [],
          "handlerMissing": true
        },
        {
          "method": "POST",
          "endpoint": "/api/upload-multiple-mailroom-document",
          "description": "Upload Multiple Documents in Mailroom section",
          "handler": "DocumentController@uploadMultipleMailRoomDocument",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/email-case-list/MultiFileUpload.jsx"
          ],
          "params": [
            {
              "name": "document_source_type",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "documents",
              "rules": "required|array",
              "from": "validation"
            },
            {
              "name": "document_sub_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_request_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_version",
              "rules": "",
              "from": "code"
            },
            {
              "name": "favourite",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_from_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_hash",
              "rules": "",
              "from": "code"
            },
            {
              "name": "ocr_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "receiver_email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_reference_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_unknown",
              "rules": "",
              "from": "code"
            },
            {
              "name": "forwarder_name",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-document-requests",
          "description": "Firstly we are fetching the document_name based on type and subtype and and request all the document name if not requested",
          "handler": "DocumentController@addRequests",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_request_setting_ids",
              "rules": "sometimes|array",
              "from": "validation"
            },
            {
              "name": "reason_for_doc_rejection",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/combine-documents",
          "description": "For combining the documents as one document",
          "handler": "DocumentController@combineDocuments",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_ids",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/combine-images",
          "description": "For combining the images as one document",
          "handler": "DocumentController@combineImages",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_ids",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/combine-word-docs",
          "description": "For combining the word documents as one pdf document",
          "handler": "DocumentController@combineWordDocs",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_ids",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/view-doc/ai-access/{document_id}",
          "description": "View Document URL",
          "handler": "DocumentController@viewDocumentURL",
          "auth": "None (public)",
          "usedBy": []
        },
        {
          "method": "GET",
          "endpoint": "/api/view-doc/{client_id}/{filename}",
          "description": "View Document URL",
          "handler": "DocumentController@viewDocumentURL",
          "auth": "None (public)",
          "usedBy": [
            "components/all-case-list/case-table/CopyLinkPopup.jsx",
            "components/client-table/client-documents/all-documents/CopyLinkPopup.jsx",
            "components/client-table/client-documents/all-documents/ShareDocumentPopup.jsx"
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get_document_request_reports",
          "description": "Fucntion is used to getting DocumentRequestReports",
          "handler": "DocumentController@getDocumentRequestReports",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "pages/DocumentsReports.jsx"
          ],
          "params": [
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            },
            {
              "name": "last_request_date",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "Mail Room",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-records-of-email-fax-scanned-docs",
          "description": "Getting Records of Email Source Type",
          "handler": "MailroomController@getRecordsOfEmailScannedFaxDocs",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "pages/EmailCaseList.jsx",
            "pages/FaxCaseList.jsx",
            "pages/ScanCaseList.jsx"
          ],
          "params": [
            {
              "name": "documentSourceType",
              "rules": "",
              "from": "code"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "modified_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_subject",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/assign-user",
          "description": "For Assigning the User",
          "handler": "MailroomController@assignUser",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/assignUser.js"
          ],
          "params": [
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "user_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/unassign-user",
          "description": "For Unassigning the User from the Documents",
          "handler": "MailroomController@unAssignUser",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/unAssignUser.js"
          ],
          "params": [
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-user-name-list",
          "description": "For Getting User Name List",
          "handler": "MailroomController@getUserNameList",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getAllAssignUsers.js"
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-assigned-user",
          "description": "For getting the list of Assigned User",
          "handler": "MailroomController@getAssignedUser",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "pages/AssignedCaseList.jsx"
          ],
          "params": [
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "modified_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            },
            {
              "name": "isAdmin",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-unassigned",
          "description": "For getting the List of Unassigned User",
          "handler": "MailroomController@getUnAssigned",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "pages/UnassignedCaseList.jsx"
          ],
          "params": [
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "modified_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-my-assigned",
          "description": "Get My Assigned User",
          "handler": "MailroomController@getMyAssignedUser",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "pages/MyAssignedCaseList.jsx"
          ],
          "params": [
            {
              "name": "document_source_type",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_source_details",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "created_at",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "isAdmin",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "modified_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-all-document-related-mailroom",
          "description": "For getting the list of documents after clicking of document count",
          "handler": "MailroomController@getAllDocRelatedMailroom",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/all-case-list/case-table/AllDocumentsList.jsx",
            "components/all-case-list/case-table/DataToolbar.jsx"
          ],
          "params": [
            {
              "name": "document_source_type",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_source_details",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "created_at",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "modified_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-client-unknown",
          "description": "Fucntion is used to get all data from Document request table for a particular contact_id",
          "handler": "MailroomController@updateClientUnknown",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/markClientUnknown.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "email",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "Document Versions",
      "apis": [
        {
          "method": "POST",
          "endpoint": "/api/save-edited-document",
          "description": "For saving edited document in document version table",
          "handler": "DocumentController@saveEditedDocument",
          "auth": "Token read, not enforced",
          "usedBy": [
            "api/pdfEditor.js"
          ],
          "params": [
            {
              "name": "document_url",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/view-version-document",
          "description": "For Viewing the Document Version",
          "handler": "DocumentController@viewDocumentVersion",
          "auth": "Bearer token (api guard)",
          "usedBy": []
        },
        {
          "method": "GET",
          "endpoint": "/api/get-document-version",
          "description": "For Gettting All Document Version",
          "handler": "DocumentController@getDocumentVersion",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/pdfVersionDetails.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        }
      ]
    },
    {
      "name": "Field Settings",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-all-fields-setting-data",
          "description": "Get records from Field Setting table",
          "descriptionFull": "Get records from Field Setting table.",
          "handler": "SettingsController@getAllFieldSettingData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/fields-setting/DataToolbar.jsx",
            "pages/FieldSettings.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fields_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "category_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fields_tab_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fields_description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-fields-setting-data",
          "description": "Add record into Field Setting table",
          "descriptionFull": "Add record into Field Setting table.",
          "handler": "SettingsController@addFieldSettingData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addClientFieldSettings.js",
            "api/addFieldSettings.js"
          ],
          "params": [
            {
              "name": "fields_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "fields_tab_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "category_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fields_description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "ocr_data",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-field-setting-table-data",
          "description": "Update record of Field Setting table",
          "descriptionFull": "Update record of Field Setting table.",
          "handler": "SettingsController@updateFieldSettingData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/changeFieldSettingsStatus.js",
            "api/editFieldSettings.js"
          ],
          "params": [
            {
              "name": "field_setting_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "fields_tab_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "category_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-field-setting-table-data",
          "description": "Delete record from Field Setting table",
          "descriptionFull": "Delete record from Field Setting table.",
          "handler": "SettingsController@deleteFieldSettingTableRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteFieldSettings.js"
          ],
          "params": [
            {
              "name": "field_setting_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-fields-setting-data-by-type",
          "description": "Get Field Setting Record By Field Tab Type",
          "handler": "SettingsController@getFieldSettingRecordByType",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getAllFieldTypeList.js"
          ],
          "params": [
            {
              "name": "fields_tab_type",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-sub-type",
          "description": "Get Sub Type",
          "handler": "SettingsController@getSubType",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getAllSubTypeList.js"
          ],
          "params": [
            {
              "name": "type",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-type-sub-type-id",
          "description": "Get Typeand Sub Type Id",
          "handler": "SettingsController@getTypeandSubTypeId",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "fields_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sub_fields_name",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-service-type-id",
          "description": "Get Field Setting ID By Field Name",
          "handler": "SettingsController@getServiceTypeId",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "fields_name",
              "rules": "required",
              "from": "validation"
            }
          ]
        }
      ]
    },
    {
      "name": "Contracts",
      "apis": [
        {
          "method": "POST",
          "endpoint": "/api/add-contract-request-setting-data",
          "description": "Add Contract Request",
          "handler": "SettingsController@addContractRequest",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addContractTemplate.js"
          ],
          "params": [
            {
              "name": "contract_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contract_description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "template_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "template_slug",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "ocr_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-contract-req-settings-data",
          "description": "Get Contract Request Settings",
          "handler": "SettingsController@getContractRequestSettings",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/contract-templates/ContractTemplatesTable.jsx",
            "components/contract-templates/DataToolbar.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contract_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contract_description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fields_name",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-contract-request-setting-data",
          "description": "function generateToken($length = 32) { return bin2hex(random_bytes($length)); }",
          "handler": "SettingsController@updateContractRequestSettingsData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/changeContractTemplatesStatus.js",
            "api/editContractTemplates.js"
          ],
          "params": [
            {
              "name": "contract_request_setting_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "is_admin",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-contract-request-setting-data",
          "description": "Delete Contract Request Setting Record",
          "handler": "SettingsController@deleteContractRequestSettingRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteContractTemplates.js"
          ],
          "params": [
            {
              "name": "contract_request_setting_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-contract-request-record",
          "description": "Add Contract Request Record",
          "handler": "ContractController@addContractRequestRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addClientContracts.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contracts",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-contract-request-data",
          "description": "Fetch Contract Request Record",
          "handler": "ContractController@getContractRequestData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/contracts/ContractsTable.jsx",
            "components/contracts/DataToolbar.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "requestType",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contract_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contract_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_by",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-contract-request-record",
          "description": "Delete Contract Request Record",
          "handler": "ContractController@deleteContractRequestTableRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteContracts.js"
          ],
          "params": [
            {
              "name": "contract_request_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/update-contract-revision",
          "description": "Update Contract Revision Url Field in Contract Request Record",
          "handler": "ContractController@updateContractRevision",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contract_request_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contracts_revision_url",
              "rules": "file",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-contract-requested-of-client",
          "description": "Get Total Number of Pending and Signed Request Of a Client",
          "handler": "ContractController@getContractRequestedOfClient",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contact_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contract_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "updated_at",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/doc-assign",
          "description": "",
          "handler": "ContractController@docAssign",
          "auth": "",
          "usedBy": [],
          "handlerMissing": true
        },
        {
          "method": "GET",
          "endpoint": "/api/get-contract-name",
          "description": "return response()->json(['message' => 'Data logged and contract request updated successfully']); }",
          "handler": "ContractController@getContractName",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/contracts/AddContracts.jsx"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-client-name-for-contract",
          "description": "Get Client Name For Contract",
          "handler": "ContractController@getClientNameForContract",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/contracts/ContractsTable.jsx"
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/update-signed-date",
          "description": "",
          "handler": "ContractController@updateSignedDate",
          "auth": "",
          "usedBy": [],
          "handlerMissing": true
        }
      ]
    },
    {
      "name": "Two-Factor Verification",
      "apis": [
        {
          "method": "POST",
          "endpoint": "/api/send-otp",
          "description": "For sending the Verification Code",
          "handler": "DocumentController@sendOTP",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/verify-otp",
          "description": "For verification of Email ID",
          "handler": "DocumentController@verifyOTP",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "verification_code",
              "rules": "required|string",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-notifications",
          "description": "For getting the Notification",
          "handler": "DocumentController@getNotification",
          "auth": "None (public)",
          "usedBy": [],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/analyze-document-separation",
          "description": "Detect the documents inside a master PDF and match them to the client's requests",
          "descriptionFull": "Detect the documents inside a master PDF and match them to the client's requests. Uses the stored ocr_full_data; generates it with the existing full-document OCR when missing or incomplete.",
          "handler": "DocumentSeparationController@analyzeDocumentSeparation",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/save-document-separation",
          "description": "Apply a reviewed separation",
          "descriptionFull": "Apply a reviewed separation. Segments linked to a request become normal documents (same records/fields as any uploaded PDF); segments without a request stay in the master PDF. Order (nothing is changed unless everything succeeds): 1. build every child PDF and the master's remaining-pages PDF locally 2. upload them to S3 as NEW files (the master's file is untouched) 3. one DB transaction: child documents + request links + split records, then the master switches to the remaining-pages version (the original stays in its version history) - or, when every page was separated, the master goes to the trash like a normal delete. Any failure deletes the uploaded files and rolls the transaction back, so the master is left exactly as it was. Duplicate protection: a per-document lock, and the source_hash from the analysis must match the current master file (after a separation the master changes, so the same analysis cannot be applied twice).",
          "handler": "DocumentSeparationController@saveDocumentSeparation",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "source_hash",
              "rules": "required|string",
              "from": "validation"
            },
            {
              "name": "segments",
              "rules": "required|array|min:1",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/audit-trail",
          "description": "Activity for the selected range, grouped by day and document, plus stats",
          "descriptionFull": "Activity for the selected range, grouped by day and document, plus stats.",
          "handler": "AuditTrailController@getAuditTrail",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "range",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/audit-trail-document",
          "description": "Full history of one document (all stored events, newest first)",
          "descriptionFull": "Full history of one document (all stored events, newest first).",
          "handler": "AuditTrailController@getDocumentAuditTrail",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "Filters",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-document-filter-name",
          "description": "For getting the filter values of document table",
          "handler": "FilterController@getDocumentFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/client-table/client-documents/all-documents/uploaded/DocumentTable.jsx",
            "components/common/DataToolbar.jsx",
            "components/document-table/DocumentTable.jsx"
          ],
          "params": [
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_request_setting_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-client-filter-name",
          "description": "For getting the Client Filter Values",
          "handler": "FilterController@getClientFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/client-table/ClientsTable.jsx",
            "components/common/DataToolbar.jsx"
          ],
          "params": [
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_reference_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-favorite-filter-name",
          "description": "For getting the Filter values of Favorite section",
          "handler": "FilterController@getFavoriteFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/starred-document-table/StarredTable.jsx"
          ],
          "params": [
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "file_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "created_by_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-assigned-filter-name",
          "description": "For getting Filter Values for All Assigned Section",
          "handler": "FilterController@getAssignedFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/all-case-list/case-list-table/CaseListTable.jsx"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-unassigned-filter-name",
          "description": "For getting Filter Values for All UnAssigned Section",
          "handler": "FilterController@getUnAssignedFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/all-case-list/case-list-table/CaseListTable.jsx"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-myunassigned-filter-name",
          "description": "For getting Filter Values for My Assigned Section",
          "handler": "FilterController@getmyAssignedFilterName",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/all-case-list/case-list-table/CaseListTable.jsx"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-email-filter-name",
          "description": "For getting Filter Values forIncoming Email Section",
          "handler": "FilterController@getemailFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/all-case-list/case-table/AllDocumentsList.jsx",
            "components/email-case-list/case-list-table/CaseListTable.jsx"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-fax-filter-name",
          "description": "For getting Filter Values for Incoming Fax Section",
          "handler": "FilterController@getfaxFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/all-case-list/case-table/AllDocumentsList.jsx",
            "components/email-case-list/case-list-table/CaseListTable.jsx"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "file_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fax_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-scan-filter-name",
          "description": "For getting Filter Values for Scanned Section",
          "handler": "FilterController@getScanFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/all-case-list/case-table/AllDocumentsList.jsx",
            "components/email-case-list/case-list-table/CaseListTable.jsx"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "file_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "scan_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-requestsettings-filter-name",
          "description": "For getting the Filter values of Document Request Settings section",
          "handler": "FilterController@getRequestSettingsFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/document-request-setting/DocumentRequestSettingsTable.jsx"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name_es",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fields_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_subtype",
              "rules": "",
              "from": "code"
            },
            {
              "name": "request_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-fieldsettings-filter-name",
          "description": "For getting the Filter values of Fields Settings section",
          "handler": "FilterController@getFieldSettingsFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/fields-setting/FieldSettingsTable.jsx"
          ],
          "params": [
            {
              "name": "fields_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fields_tab_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "fields_description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "category_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-user-filter-name",
          "description": "For getting the Filter values of User section",
          "handler": "FilterController@getUserFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/user-table/UserTable.jsx"
          ],
          "params": [
            {
              "name": "user_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "first_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "last_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "is_admin",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-request-filter-name",
          "description": "For getting the Filter values of Requests section",
          "handler": "FilterController@getRequestFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/requests/RequestsTable.jsx"
          ],
          "params": [
            {
              "name": "requested_by",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "contact_type",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-deleteduser-filter-name",
          "description": "For getting the Filter values of Deleted User section",
          "handler": "FilterController@getDeletedUserFilterName",
          "auth": "None (public)",
          "usedBy": [
            "pages/TrashUsers.jsx"
          ],
          "params": [
            {
              "name": "user_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "first_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "last_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "is_admin",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-deleteddocument-filter-name",
          "description": "For getting the Filter values of Deleted Document section",
          "handler": "FilterController@getDeletedDocumentFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/bin/document-bin/TrashDocumentsTable.jsx"
          ],
          "params": [
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_request_setting_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "del_doc_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_subtype",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-documentrequest-filter-name",
          "description": "For getting the Filter values of Document Request section",
          "handler": "FilterController@getDocumentRequestFilterData",
          "auth": "None (public)",
          "usedBy": [
            "components/client-table/client-documents/RequestedDocumentsTable.jsx"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_req_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_category",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-insidefolder-filter-name",
          "description": "For getting the Filter values of Inside folder record in Mailroom section",
          "handler": "FilterController@getinsideFolderFilterName",
          "auth": "None (public)",
          "usedBy": [],
          "params": [
            {
              "name": "document_source_type",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_source_details",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "created_at",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-role-filter-name",
          "description": "For getting the Filter values of the Roles section (name, status)",
          "handler": "FilterController@getRoleFilterName",
          "auth": "None (public)",
          "usedBy": [
            "components/role-table/RoleTable.jsx"
          ],
          "params": [
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "Client Portal",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-document-req-stages",
          "description": "For Getting the Document Stages based on ContactID",
          "handler": "ClgCasePortalCotntroller@getDocumentReqSettingsStages",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/client-table/client-documents/RequestDocumentsPopup.jsx"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-beneficiary",
          "description": "For Adding Beneficiary",
          "handler": "ClgCasePortalCotntroller@addBeneficiary",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "linked_client_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "country_code",
              "rules": "",
              "from": "code"
            },
            {
              "name": "phone_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-beneficiary-name",
          "description": "For getting all Beneficary Names of contact_id",
          "handler": "ClgCasePortalCotntroller@getBeneficiaryName",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-type-list",
          "description": "For getting Type List",
          "handler": "ClgCasePortalCotntroller@getTypeList",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "category_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-document-stages",
          "description": "For Getting the services as Document Stages",
          "handler": "ClgCasePortalCotntroller@getDocumentStages",
          "auth": "Bearer token (api guard)",
          "usedBy": []
        },
        {
          "method": "POST",
          "endpoint": "/api/add-Client-Portal-Additional-Document",
          "description": "We are adding documents based on client_id, fetching the case_ids associated with it, and then adding the documents for those case_ids",
          "descriptionFull": "We are adding documents based on client_id, fetching the case_ids associated with it, and then adding the documents for those case_ids.",
          "handler": "ClgCasePortalCotntroller@addAdditionalDocumentForClientPortal",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_url",
              "rules": "required|file",
              "from": "validation"
            },
            {
              "name": "phone",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "OCR",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-ocr-keys",
          "description": "For Getting the OCR values",
          "handler": "OCRController@getOcrKeys",
          "auth": "Bearer token (api guard)",
          "usedBy": []
        },
        {
          "method": "GET",
          "endpoint": "/api/get-subtype-ocr-keys",
          "description": "For Getting the OCR values based on document sub category",
          "handler": "OCRController@getSubTypeOcrKeys",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/common/ocr/OcrFields.jsx",
            "components/common/ocr/OcrPopup.jsx"
          ],
          "params": [
            {
              "name": "document_sub_category",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-ocr-data",
          "description": "Get records from OCR Data table",
          "descriptionFull": "Get records from OCR Data table.",
          "handler": "OCRController@getAllOCRData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/common/ocr/OcrFields.jsx",
            "components/common/ocr/OcrPopup.jsx"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-ocr-data",
          "description": "Add record into OCR Data table",
          "descriptionFull": "Add record into OCR Data table.",
          "handler": "OCRController@addOCRData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/pdf-viewer/PdfViewer.jsx"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "ocr_data",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/update-ocr-data",
          "description": "Update record of OCR Data table",
          "descriptionFull": "Update record of OCR Data table.",
          "handler": "OCRController@updateOCRData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/pdf-viewer/PdfViewer.jsx"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "ocr_data",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-ocr-data",
          "description": "Delete record from OCR Data table",
          "descriptionFull": "Delete record from OCR Data table.",
          "handler": "OCRController@deleteOCRData",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/process-pdf-ocr",
          "description": "PDF OCR flow: rasterize the PDF, call OpenAI directly (no Python), and persist the extracted fields using the same ocr_data save logic…",
          "descriptionFull": "PDF OCR flow: rasterize the PDF, call OpenAI directly (no Python), and persist the extracted fields using the same ocr_data save logic as addOCRData/updateOCRData. Reuses the existing fields_setting/document_identifier lookup used by getSubTypeOcrKeys. Does not modify the existing Image OCR flow.",
          "handler": "OCRController@processPdfOcr",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "components/common/ocr/OcrPopup.jsx"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_sub_category",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "file",
              "rules": "required|file|mimes:pdf|max:20480",
              "from": "validation"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/process-ocr-full-data",
          "description": "Full-document OCR JSON: extract every page of the PDF (one OCR call per page, no page limit) grouped by page - category - sections /…",
          "descriptionFull": "Full-document OCR JSON: extract every page of the PDF (one OCR call per page, no page limit) grouped by page - category - sections / tables, and store it in ocr_data.ocr_full_data. Called by the UI right after a successful Perform OCR / Re-OCR, so it always overwrites the previous full JSON. Writes ONLY ocr_full_data; the existing ocr_data column and OCR flow are not touched.",
          "handler": "OCRController@processOcrFullData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/processOcrFullData.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "file",
              "rules": "required|file|mimes:pdf",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-ocr-full-data",
          "description": "Read-only: the stored full-document OCR JSON for a document (null when it has not been generated yet)",
          "descriptionFull": "Read-only: the stored full-document OCR JSON for a document (null when it has not been generated yet).",
          "handler": "OCRController@getOcrFullData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getOcrFullData.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/save-image-ocr-full-data",
          "description": "Save the answers returned by the existing image OCR (Filescour) into ocr_data.ocr_full_data, in the same structure as the PDF…",
          "descriptionFull": "Save the answers returned by the existing image OCR (Filescour) into ocr_data.ocr_full_data, in the same structure as the PDF full-document JSON so the View panel can show it. No new OCR call is made; the values are stored as returned. Re-OCR overwrites it.",
          "handler": "OCRController@saveImageOcrFullData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/saveImageOcrFullData.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "answers",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/update-ocr-full-data",
          "description": "Save user corrections from the \"Extracted Document Data\" panel: edited values and removed fields",
          "descriptionFull": "Save user corrections from the \"Extracted Document Data\" panel: edited values and removed fields. Only the pages of the stored ocr_full_data are replaced (normalised to the same page shape); ocr_data and the document itself are not touched. Re-OCR still overwrites ocr_full_data as before.",
          "handler": "OCRController@updateOcrFullData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/updateOcrFullData.js"
          ],
          "params": [
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "pages",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "Document Upload & Ingestion",
      "apis": [
        {
          "method": "POST",
          "endpoint": "/api/add-task",
          "description": "",
          "handler": "DocumentController@addTask",
          "auth": "",
          "usedBy": [],
          "handlerMissing": true
        },
        {
          "method": "POST",
          "endpoint": "/api/upload_documents",
          "description": "Upload API",
          "descriptionFull": "Upload API)",
          "handler": "DocumentController@uploadDocuments",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "folder_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email",
              "rules": "",
              "from": "code"
            },
            {
              "name": "user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "case_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_title",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_desc",
              "rules": "",
              "from": "code"
            },
            {
              "name": "category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "case_cat_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "CreatedDate",
              "rules": "",
              "from": "code"
            },
            {
              "name": "LastUpload",
              "rules": "",
              "from": "code"
            },
            {
              "name": "lead_id_guid",
              "rules": "",
              "from": "code"
            },
            {
              "name": "case_id_guid",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_name",
              "rules": "file",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get_document",
          "description": "Get Document Link",
          "descriptionFull": "Get Document Link)",
          "handler": "DocumentController@getDocuments",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/update_documentsRec",
          "description": "Update Document",
          "descriptionFull": "Update Document)",
          "handler": "DocumentController@updateDocumentsRec",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_sub_category",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-old-files",
          "description": "Delete Old Files just before the day of today, (Job Scheduler)",
          "handler": "DocumentController@deleteOldFiles",
          "auth": "None (public)",
          "usedBy": []
        },
        {
          "method": "POST",
          "endpoint": "/api/add-Email-Document",
          "description": "For adding the document without contact_id,request_id,clientReferenceNumber",
          "descriptionFull": "For adding the document without contact_id,request_id,clientReferenceNumber)",
          "handler": "DocumentController@addDocumentDataFromEmail",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_url",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_sub_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "content_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "subject",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_version",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_from_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "favourite",
              "rules": "",
              "from": "code"
            },
            {
              "name": "forwarder_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_hash",
              "rules": "",
              "from": "code"
            },
            {
              "name": "ocr_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "receiver_email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_reference_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_unknown",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-Sharepoint-Document",
          "description": "Add document data uploaded via the Sharepoint integration endpoint",
          "handler": "DocumentController@addDocumentDataFromSharepoint",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "document_name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_url",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_sub_category",
              "rules": "",
              "from": "code"
            },
            {
              "name": "description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "content_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_version",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_details",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "document_source_from_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "forwarder_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "assign_user_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "email_hash",
              "rules": "",
              "from": "code"
            },
            {
              "name": "ocr_status",
              "rules": "",
              "from": "code"
            },
            {
              "name": "receiver_email_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_reference_number",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_unknown",
              "rules": "",
              "from": "code"
            }
          ]
        }
      ]
    },
    {
      "name": "Email Templates",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-all-email-template-data",
          "description": "List email templates for the Settings Email Templates screen",
          "descriptionFull": "List email templates for the Settings Email Templates screen. Response shape mirrors SettingsController::getAllFieldSettingData's existing convention: {data: [{cases, allCasesCount}], message, code}.",
          "handler": "EmailTemplateController@getAllEmailTemplates",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "pages/EmailTemplates.jsx"
          ],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/add-email-template-data",
          "description": "Add record into Email Templates table",
          "descriptionFull": "Add record into Email Templates table.",
          "handler": "EmailTemplateController@addEmailTemplateData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/addEmailTemplateData.js"
          ],
          "params": [
            {
              "name": "name",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "subject",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "body_html",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "language",
              "rules": "nullable|in:en,es|required_if:type,document_request,document_rejected,document_accepted",
              "from": "validation"
            },
            {
              "name": "description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "PUT",
          "endpoint": "/api/update-email-template-data",
          "description": "Update record of Email Templates table",
          "descriptionFull": "Update record of Email Templates table. Also used for Enable/Disable via the status field.",
          "handler": "EmailTemplateController@updateEmailTemplateData",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/updateEmailTemplateData.js"
          ],
          "params": [
            {
              "name": "id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "language",
              "rules": "nullable|in:en,es|required_if:type,document_request,document_rejected,document_accepted",
              "from": "validation"
            },
            {
              "name": "name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "description",
              "rules": "",
              "from": "code"
            },
            {
              "name": "type",
              "rules": "",
              "from": "code"
            },
            {
              "name": "subject",
              "rules": "",
              "from": "code"
            },
            {
              "name": "body_html",
              "rules": "",
              "from": "code"
            },
            {
              "name": "status",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "DELETE",
          "endpoint": "/api/delete-email-template-table-data",
          "description": "Soft-delete record(s) from Email Templates table",
          "descriptionFull": "Soft-delete record(s) from Email Templates table.",
          "handler": "EmailTemplateController@deleteEmailTemplateTableRecord",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/deleteEmailTemplateTableRecord.js"
          ],
          "params": [
            {
              "name": "id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-active-email-templates",
          "description": "Active-only, alphabetical list for the Document Chasing template dropdown",
          "handler": "EmailTemplateController@getActiveEmailTemplates",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getActiveEmailTemplates.js"
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/preview-email-template",
          "description": "Resolve a template's {{Placeholder}} tokens for the Settings-side Preview action",
          "descriptionFull": "Resolve a template's {{Placeholder}} tokens for the Settings-side Preview action. Uses the same EmailTemplateResolver as the Document Chasing send flow.",
          "handler": "EmailTemplateController@previewEmailTemplate",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/previewEmailTemplate.js"
          ],
          "params": [
            {
              "name": "id",
              "rules": "required",
              "from": "validation"
            }
          ]
        }
      ]
    },
    {
      "name": "Document Chasing",
      "apis": [
        {
          "method": "GET",
          "endpoint": "/api/get-client-chasing-summary",
          "description": "Get Client Chasing Summary",
          "handler": "DocumentChasingController@getClientChasingSummary",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getClientChasingSummary.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-document-chasing-clients",
          "description": "Client list for the Document Chasing page: ONLY clients that need chasing, using the same eligibility rule as the \"Chase Documents\"…",
          "descriptionFull": "Client list for the Document Chasing page: ONLY clients that need chasing, using the same eligibility rule as the \"Chase Documents\" modal (BulkDocumentChasingPopup): requested_count uploaded_count (i.e. requested - uploaded 0; compared directly, both unsigned). Same parameters, columns, filters, search, sorting, pagination and response shape as get-all-client-data, so the existing clients table renders it unchanged. get-all-client-data itself is not modified.",
          "handler": "DocumentChasingController@getDocumentChasingClients",
          "auth": "Bearer token (api guard)",
          "usedBy": [],
          "params": [
            {
              "name": "userId",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "isAdmin",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "limit",
              "rules": "",
              "from": "code"
            },
            {
              "name": "offset",
              "rules": "",
              "from": "code"
            },
            {
              "name": "sort",
              "rules": "",
              "from": "code"
            },
            {
              "name": "client_name",
              "rules": "",
              "from": "code"
            },
            {
              "name": "global_search",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-client-pending-chasing-documents",
          "description": "Get Pending Chasing Documents",
          "handler": "DocumentChasingController@getPendingChasingDocuments",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getPendingChasingDocuments.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_request_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "exclude_document_request_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/preview-chasing-email",
          "description": "Preview Chasing Email",
          "handler": "DocumentChasingController@previewChasingEmail",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/previewChasingEmail.js"
          ],
          "params": [
            {
              "name": "template_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "document_request_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "exclude_document_request_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "POST",
          "endpoint": "/api/send-chasing-email",
          "description": "Send Chasing Email",
          "handler": "DocumentChasingController@sendChasingEmail",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/sendChasingEmail.js"
          ],
          "params": [
            {
              "name": "template_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            },
            {
              "name": "recipient_email",
              "rules": "required|email",
              "from": "validation"
            },
            {
              "name": "document_request_id",
              "rules": "",
              "from": "code"
            },
            {
              "name": "exclude_document_request_id",
              "rules": "",
              "from": "code"
            }
          ]
        },
        {
          "method": "GET",
          "endpoint": "/api/get-chasing-history",
          "description": "Get Chasing History",
          "handler": "DocumentChasingController@getChasingHistory",
          "auth": "Bearer token (api guard)",
          "usedBy": [
            "api/getChasingHistory.js"
          ],
          "params": [
            {
              "name": "contact_id",
              "rules": "required",
              "from": "validation"
            }
          ]
        }
      ]
    }
  ]
};

export default dmsApiInventory;
